import { vars } from "@frontend/styles";
import type { StyleRule } from "@vanilla-extract/css";

import type { DataTableSize, DataTableSpacing } from "./DataTable.types";

export const cellFontSizeStyles: Record<DataTableSize, StyleRule> = {
  sm: { fontSize: vars.font.size.sm },
  md: { fontSize: vars.font.size.md },
  lg: { fontSize: vars.font.size.lg },
};

export const dataTableSpacingValue: Record<DataTableSpacing, string> = {
  xs: vars.spacing.xs,
  sm: vars.spacing.sm,
  md: vars.spacing.md,
  lg: vars.spacing.lg,
  xl: vars.spacing.xl,
};

export const sortedColumnBackground = `color-mix(in srgb, ${vars.color.primary} 5%, transparent)`;

export const sortedColumnLayer = `linear-gradient(${sortedColumnBackground}, ${sortedColumnBackground})`;
